import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  return [
    {
      menuId: 16,
      icon: 'config',
      name: i18n.t('tipos.modulo_name.verifactu'),
      path: 'verifactu',
      use_parent_params: true,
      // Pendiente: meter los 4 params
      params_required: ['IdCliente', 'IdCifEmpresa', 'NumSerieFactura', 'FechaExpedicion'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'verifactu/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        // {
        //   name: i18n.t('historical.entity_name'),
        //   path: 'verifactu/historical',
        //   params,
        //   registerNavFromMenu: false,
        //   sc: [] // shorcuts
        // },
      ]
    }
  ]
}
